<template>
  <v-layout column text-xs-center>
    <v-container flex-column align-center>
      <v-layout class="title font-weight-bold" id="resultDiv">
        {{$t('webTransfer.enterCodeShort')}}
      </v-layout>
      <v-container fluid d-flex justify-center>
        <v-flex
          v-for="(digit, index) in code"
          class="code_number"
          :key="digit + index"
        >
          {{digit}}
        </v-flex>
      </v-container>
      <div>
        {{$t('sendCode.codeExpires')}} {{getCodeExpiration()}}
      </div>
      <slot></slot>
    </v-container>
    <div class="divider-flat"></div>
    <v-container flex-column align-center justify-center>
      <span class="font-weight-bold">{{$t('webTransfer.codeInstructionTitle')}}</span>
      &nbsp;
      <ol class="text-xs-left">
        <li>{{$t('webTransfer.codeInstructionStep1')}}</li>
        <li>{{$t('webTransfer.codeInstructionStep2')}}</li>
        <li>{{$t('webTransfer.codeInstructionStep3')}}</li>
        <li>{{$t('webTransfer.codeInstructionStep4')}}</li>
      </ol>
    </v-container>
  </v-layout>
</template>

<script>
const moment = require('moment')

export default {
  name: 'CodeTransferComplete',
  props: {
    code: {
      type: String,
      required: true
    },
    daysUntilCodeExpires: {
      type: Number,
      required: true
    }
  },
  methods: {
    getCodeExpiration () {
      let expDate = moment().add(this.daysUntilCodeExpires, 'days')
      let result = expDate.format('LT')
      result += ' ' + window.i18n.t('common.onDate') + ' '
      result += expDate.format('l')
      return result
    }
  }
}
</script>

<style scoped>
</style>
